import { jsx as _jsx } from "react/jsx-runtime";
import { Children } from "react";
import * as S from "./styled.js";
export const ScrollHorizontal = ({ className , children , gap ='8px'  })=>/*#__PURE__*/ _jsx(S.ScrollHorizontalList, {
        className: className,
        $gap: gap,
        "data-testid": "ScrollHorizontal",
        children: Children.map(children, (child)=>/*#__PURE__*/ _jsx(S.ScrollHorizontalItem, {
                children: child
            }))
    });
export default ScrollHorizontal;

//# sourceMappingURL=index.js.map